import abbottSmall from "../assets/abbottSmall.png";
import pediasure from "../assets/ensureGoldImage2.png";
import waReward from "../assets/redeemCoin.png";
import waSteps from "../assets/wa-steps.png";
import waRedeem from "../assets/wa-redeem.png";
import waStepsShopee from "../assets/wa-steps-shopee.png";
import shopee from "../assets/shopee.png";
import spayGlobal from "../assets/spayGlobal.png";
import spayGlobalSteps from "../assets/wa-steps-spayglobal.png";
import canWithShield from "../assets/canWithShield.png";
import {
  ABBOTT_PHONE,
  PRIVACY_LINK,
  TERMS_LINK,
  SHOPEE_TERMS_LINK,
  SPAY_TERMS_LINK,
  WHATSAPP_BASE_URL,
  SALE_REP_REWARD_MAPPING,
} from "../constants/link";

const LandingPage = () => {
  const params = new URLSearchParams(window.location.search);
  const uniqueCode = params.get("code");

  const reward = uniqueCode
    ? SALE_REP_REWARD_MAPPING[uniqueCode] || "TNG"
    : "TNG";

  const waStepsImage =
    reward === "Shopee"
      ? waStepsShopee
      : reward === "Sarawak Pay"
      ? spayGlobalSteps
      : waSteps;
  const rewardImage =
    reward === "Shopee"
      ? shopee
      : reward === "Sarawak Pay"
      ? spayGlobal
      : waReward;

  const termOfServiceLink =
    reward === "Shopee"
      ? SHOPEE_TERMS_LINK
      : reward === "Sarawak Pay"
      ? SPAY_TERMS_LINK
      : TERMS_LINK;

  // const whatsappText = ``;

  const handleClick = () => {
    if (uniqueCode) {
      const url = `${WHATSAPP_BASE_URL}?phone=${ABBOTT_PHONE}&text=Click%20Send%20to%20Redeem%20RM10%20voucher%20now!%20(Special%20Code%3A%20${uniqueCode})`;
      window.location.href = url;
    }
  };

  return (
    <div className="w-full  p-4 mt-5 items-center flex flex-row text-center bg-white shadow-lg rounded-lg  max-w-">
      <div className="whatsapp-bg text-center">
        <div className="whatsapp-topbar">
          <img src={abbottSmall} alt="abbott" className="img-fluid img" />
          <img src={pediasure} alt="pediasure" className="img-fluid img" />
        </div>
        <div>
          <p
            style={{
              textAlign: "center",
              fontSize: "36px",
              fontWeight: "bold",
              margin: "0px",
              padding: "0 20px",
            }}
          >
            Welcome to
            <br />
            Abbott Care Pack
          </p>
        </div>
        <div
          className="px-5"
          style={{ padding: "0 20px", display: "grid", gap: "20px" }}
        >
          <img src={rewardImage} alt="wa-reward" className="img-fluid" />
          <img src={waStepsImage} alt="wa-steps" className="img-fluid mt-4" />

          <div style={{ textAlign: "center" }}>
            <button
              onClick={handleClick}
              style={{
                border: "none",
                cursor: "pointer",
                backgroundColor: "transparent",
              }}
            >
              <img
                src={waRedeem}
                alt="btn"
                className="img-fluid mt-4 mx-auto"
                style={{ width: "70%" }}
              />
            </button>

            {/* If code is missing */}
            {!uniqueCode && (
              <p
                style={{
                  color: "#cc0000",
                  marginTop: "10px",
                  fontSize: "14px",
                }}
              >
                Code is missing. Please check your link.
              </p>
            )}

            <div className="mt-3" style={{ paddingTop: "10px" }}>
              <a
                style={{
                  color: "white",
                  textDecoration: "underline",
                  margin: "0 10px",
                }}
                href={termOfServiceLink}
                target="_blank"
                rel="noopener noreferrer"
              >
                Term &amp; Conditions
              </a>
              <a
                style={{
                  color: "white",
                  textDecoration: "underline",
                  margin: "0 10px",
                }}
                href={PRIVACY_LINK}
                target="_blank"
                rel="noopener noreferrer"
              >
                Privacy Policy
              </a>
            </div>
          </div>
        </div>

        <div style={{ display: "flex", placeContent: "center" }}>
          <img
            src={canWithShield}
            alt="grow"
            style={{ width: "150%", margin: "0 auto" }}
          />
        </div>
      </div>
    </div>
  );
};

export default LandingPage;
